// Essential reserved subdomains (keep this list minimal but comprehensive)
const RESERVED_SUBDOMAINS = [
    // Core system
    'www', 'app', 'api', 'admin', 'dashboard', 'panel', 'blog', 'vendor',

    // Authentication
    'auth', 'login', 'register', 'signup', 'signin', 'logout',

    // Infrastructure
    'cdn', 'static', 'assets', 'media', 'mail', 'ftp', 'dev', 'test', 'staging', 'prod',

    // Business terms
    'store', 'shop', 'catalog', 'catalogs', 'pricilog', 'pricing', 'price',

    // Common protocols
    'http', 'https', 'ws', 'wss', 'ssl', 'secure',

    // Support
    'help', 'support', 'docs', 'faq', 'contact', 'about',

    // Payment
    'payment', 'pay', 'checkout', 'billing',
];

const RESERVED_PATTERNS = [
    /^admin.*/,
    /^api.*/,
    /^www.*/,
    /^mail.*/,
    /^test.*/,
    /^\d+$/,           // purely numeric
    /^[a-z]$/,         // single character
    /^[a-z]{2}$/,      // two characters
];

export function validateSubdomainClient(subdomain) {
    if (!subdomain || typeof subdomain !== 'string') {
        return { isValid: false, error: 'Store Link is required' };
    }

    const normalized = subdomain.toLowerCase().trim();

    // Length check
    if (normalized.length < 3) {
        return { isValid: false, error: 'Store Link must be at least 3 characters long' };
    }
    if (normalized.length > 32) {
        return { isValid: false, error: 'Store Link cannot be longer than 32 characters' };
    }

    // Format check
    if (!/^[a-z0-9][a-z0-9-]*[a-z0-9]$/.test(normalized)) {
        return { isValid: false, error: 'Store Link can only contain letters, numbers, and hyphens. Cannot start or end with a hyphen.' };
    }

    // Reserved check
    if (RESERVED_SUBDOMAINS.includes(normalized)) {
        return { isValid: false, error: 'This subdomain is reserved and cannot be used' };
    }

    // Pattern check
    for (const pattern of RESERVED_PATTERNS) {
        if (pattern.test(normalized)) {
            return { isValid: false, error: 'This subdomain is reserved and cannot be used' };
        }
    }

    return { isValid: true, error: null };
}

export function generateSuggestions(requestedName) {
    const base = requestedName.toLowerCase().replace(/[^a-z0-9]/g, '');
    const suggestions = [];

    // Smart suggestion strategies
    const strategies = [
        // Strategy 1: Add business-friendly prefixes
        () => {
            const prefixes = ['my', 'get', 'the'];
            return prefixes.map(prefix => `${prefix}${base}`);
        },

        // Strategy 2: Add business-friendly suffixes
        () => {
            const suffixes = ['shop', 'store', 'co', 'hub', 'place'];
            return suffixes.map(suffix => `${base}${suffix}`);
        },

        // Strategy 3: Add variations with separators
        () => {
            return [`${base}-shop`, `${base}-store`, `shop-${base}`];
        },

        // Strategy 4: Add numbers
        () => {
            return [1, 2, 3].map(num => `${base}${num}`);
        }


    ];

    // Execute strategies and collect valid suggestions
    strategies.forEach(strategy => {
        const candidates = strategy();
        candidates.forEach(candidate => {
            if (suggestions.length >= 5) return;
            if (candidate && validateSubdomainClient(candidate).isValid && candidate.length <= 32) {
                // Avoid duplicates
                if (!suggestions.includes(candidate)) {
                    suggestions.push(candidate);
                }
            }
        });
    });

    return suggestions.slice(0, 5);
}